import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export interface KpiSubMetric {
  label: string;
  value: string | number;
  valueColor?: string;
}

export interface KpiCardItem {
  title?: string;
  label?: string;
  value?: string | number;
  subtitle?: string;
  icon?: string;
  svgPath?: string;
  accentColor?: string;
  valueColor?: string;
  iconBgColor?: string;
  iconBorderColor?: string;
  iconColor?: string;
  loading?: boolean;
  theme?: string;
  subMetrics?: KpiSubMetric[];
}

@Component({
  selector: 'lib-kpi-card',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  host: { class: 'block w-full h-full' },
  templateUrl: './kpi-card.component.html',
  styleUrl: './kpi-card.component.scss',
})
export class KpiCardComponent {
  @Input() title: string = '';
  @Input() label: string = '';
  @Input() value: string | number = 0;
  @Input() subtitle?: string;
  @Input() icon?: string;
  @Input() svgPath?: string;
  @Input() accentColor?: string = '#3a7ca5';
  @Input() valueColor?: string = '#1e3a8a';
  @Input() iconBgColor?: string = '#f0f7ff';
  @Input() iconBorderColor?: string = '#d0e2ff';
  @Input() iconColor?: string = '#2563eb';
  @Input() loading?: boolean = false;
  @Input() theme?: string;
  @Input() subMetrics?: KpiSubMetric[];

  @Input() set card(data: KpiCardItem | undefined) {
    if (data) {
      if (data.title !== undefined) this.title = data.title;
      if (data.label !== undefined) this.label = data.label;
      if (data.value !== undefined) this.value = data.value;
      if (data.subtitle !== undefined) this.subtitle = data.subtitle;
      if (data.icon !== undefined) this.icon = data.icon;
      if (data.svgPath !== undefined) this.svgPath = data.svgPath;
      if (data.accentColor !== undefined) this.accentColor = data.accentColor;
      if (data.valueColor !== undefined) this.valueColor = data.valueColor;
      if (data.iconBgColor !== undefined) this.iconBgColor = data.iconBgColor;
      if (data.iconBorderColor !== undefined) this.iconBorderColor = data.iconBorderColor;
      if (data.iconColor !== undefined) this.iconColor = data.iconColor;
      if (data.loading !== undefined) this.loading = data.loading;
      if (data.theme !== undefined) this.theme = data.theme;
      if (data.subMetrics !== undefined) this.subMetrics = data.subMetrics;
    }
  }
}
